// src/components/Footer.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTiktok, FaSnapchat, FaReddit, FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

function Footer() {
  useEffect(() => {
    // Check if the script is already loaded to avoid duplicates
    if (!document.querySelector('script[src="https://embed.tawk.to/67f53614c8dab5190d8ef120/1ioatmgee"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://embed.tawk.to/67f53614c8dab5190d8ef120/1ioatmgee';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      document.body.appendChild(script);
    }
  }, []);

  return (
    <footer className="footer">
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1rem' }}>
        {/* Footer Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem'
        }}>
          {/* Contact Info */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>Contact Us</h4>
            <p style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <FaMapMarkerAlt /> 24-25 New Rd, Gravesend DA11 0AA
            </p>
            <p style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <FaEnvelope /> <a href="mailto:support@kentechphonerepairs.co.uk" style={{ color: 'inherit' }}>support@kentechphonerepairs.co.uk</a>
            </p>
            <p style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <FaPhone /> <a href="tel:+447944859580" style={{ color: 'inherit' }}>07944 859580</a>
            </p>
            <p style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <FaWhatsapp /> <a href="https://wa.me/447944859580" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>WhatsApp Us</a>
            </p>
          </div>

          {/* Quick Links */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>Quick Links</h4>
            <p className="footer-links" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <Link to="/about">About Us</Link>
              <Link to="/location">Our Location</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/booking">Book Repair</Link>
            </p>
          </div>

          {/* Legal */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>Legal</h4>
            <p className="footer-links" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms">Terms & Conditions</Link>
              <Link to="/warranty">Warranty</Link>
              <Link to="/complain">Complaints</Link>
            </p>
          </div>

          {/* Social Media */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>Follow Us</h4>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', fontSize: '1.5rem', flexWrap: 'wrap' }}>
              <a href="https://facebook.com/kentechphones" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaFacebook />
              </a>
              <a href="https://instagram.com/kentechphones" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaInstagram />
              </a>
              <a href="https://tiktok.com/@kentechphones" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaTiktok />
              </a>
              <a href="https://snapchat.com/add/kentechphones" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaSnapchat />
              </a>
              <a href="https://twitter.com/kentechphones" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaXTwitter />
              </a>
              <a href="https://reddit.com/r/kentechphones" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaReddit />
              </a>
              <a href="https://wa.me/447944859580" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', transition: 'color 0.3s' }}>
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '1rem', textAlign: 'center' }}>
          <p>© {new Date().getFullYear()} Kentech Phones. All rights reserved.</p>
          <p className="footer-credit" style={{ fontSize: '0.9rem', marginTop: '10px', opacity: 0.8 }}>
            Web app created by <a href="https://softeefi.co.uk" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Softeefi</a> | <Link to="/admin/login" style={{ color: 'inherit' }}>Admin</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;